export const footerLinks = [
  {
    titleHeader: "Company",
    title: [
      { Name: "About Us", href: "about-us" },
      { Name: "Contact Us", href: "contact-us" },
      { Name: "FAQ", href: "faq" },
    ],
  },
  {
    titleHeader: "My Account",
    title: [
      { Name: "Dashboard", href: "/user/dashboard" },
      { Name: "My Orders", href: "/user/dashboard" },
      { Name: "Update Profile", href: "/user/update-profile" },
    ],
  },
  {
    titleHeader: "Legal",
    title: [
      { Name: "Privacy Policy", href: "/privacy" },
      { Name: "Terms of Service", href: "/terms" },
      { Name: "Delete Account", href: "/delete-account" },
    ],
  },
];
